import Carousel from "@/components/Carousel";
import { Pressable } from '@/components/Theme';
import { PLACEHOLDER_IMAGE_WEB } from '@/constants/Core';
import { mediaFormatter } from "@/helper/File";
import { NoContextImage } from '@/components/Image';
import isEqual from 'lodash/isEqual';
import { memo, useCallback, useMemo, useRef } from "react";
import { ScrollView } from "react-native-gesture-handler";
import { replaceParts } from "@/helper/Core";

const NO_IMAGE_TPL = {
    uri: PLACEHOLDER_IMAGE_WEB,
    originalUri: PLACEHOLDER_IMAGE_WEB,
    name: 'PLACEHOLDER',
    mediaType: 'image/webp',
    width: 1280, 
    height: 720, 
};

export default memo((props) => {
    const { media = [] } = props;

    const formattedMedia = useMemo(() => {

        const newMapped = media?.map(item => ({
            ...item,
            uri: replaceParts(item?.src, [
                ['resize=600', 'resize=1280']
            ]),
            alternativeText: item?.alt ?? null,
            thumb: replaceParts(item?.src, [
                ['resize=600', 'resize=100']
            ])
        }));

        return mediaFormatter(newMapped);
    }, [media]);
    
    const carouselRef = useRef(null);
    
    const onPressImageThumb = (index) => {
        carouselRef.current?.open(index);
    };

    const renderThumb = useCallback( ({item, index}) => (
        <Pressable onPress={() => onPressImageThumb(index)}>
            <NoContextImage 
                style={{width: 100, height: 100}} 
                source={{uri: item?.thumb}} 
                fetchPriority="high"
                accessibilityLabel={item?.alternativeText ?? item?.title}
                accessibilityRole="image"
            />
        </Pressable>    
    ), [formattedMedia]);

    const mediaThumbsMap = useMemo(() => 
        formattedMedia?.length <= 1 ? [] : formattedMedia?.map((item, index) => renderThumb({item, index}))
    , [formattedMedia, renderThumb]);

    return (
        <>
            <Carousel
                ref={carouselRef}
                showFirst={false}
                showGrid={true}
                media={Array.isArray(formattedMedia) && formattedMedia?.length > 0 ? formattedMedia : [NO_IMAGE_TPL]} 
                ratio={500/.1}
            />
            
            {formattedMedia?.length > 1 && 
                <ScrollView 
                    horizontal={true} 
                    showsHorizontalScrollIndicator={false} 
                    showsVerticalScrollIndicator={false} 
                    style={{width: '100%'}} 
                    contentContainerStyle={{flexDirection: 'row', paddingTop: 25, gap: 25, width: '100%'}} >
                    {mediaThumbsMap}
                </ScrollView>
            }
        </>
    )
}, isEqual);